module.exports = __webpack_public_path__ + "static/media/pieDePiedra.dee7ae1c.webp";